/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1SsoimageIdVideo202,
  DeleteApiV1SsoimageIdVideo400,
  DeleteApiV1SsoimageIdVideo401,
  DeleteApiV1SsoimageIdVideo404,
  DeleteApiV1SsoimageIdVideo500,
  DeleteApiV1SsoimageIdVideoMutationRequest,
  DeleteApiV1SsoimageIdVideoMutationResponse,
  DeleteApiV1SsoimageIdVideoPathParams,
} from "../../types/SSOImageController/DeleteApiV1SsoimageIdVideo.ts";
import { deleteSSOVideoViewModelSchema } from "../deleteSSOVideoViewModelSchema.ts";

export const deleteApiV1SsoimageIdVideoPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<DeleteApiV1SsoimageIdVideoPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const deleteApiV1SsoimageIdVideo202Schema =
  z.any() as unknown as ToZod<DeleteApiV1SsoimageIdVideo202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const deleteApiV1SsoimageIdVideo400Schema =
  z.any() as unknown as ToZod<DeleteApiV1SsoimageIdVideo400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1SsoimageIdVideo401Schema =
  z.any() as unknown as ToZod<DeleteApiV1SsoimageIdVideo401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1SsoimageIdVideo404Schema =
  z.any() as unknown as ToZod<DeleteApiV1SsoimageIdVideo404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1SsoimageIdVideo500Schema =
  z.any() as unknown as ToZod<DeleteApiV1SsoimageIdVideo500>;

export const deleteApiV1SsoimageIdVideoMutationRequestSchema = z.lazy(
  () => deleteSSOVideoViewModelSchema,
) as unknown as ToZod<DeleteApiV1SsoimageIdVideoMutationRequest>;

export const deleteApiV1SsoimageIdVideoMutationResponseSchema = z.lazy(
  () => deleteApiV1SsoimageIdVideo202Schema,
) as unknown as ToZod<DeleteApiV1SsoimageIdVideoMutationResponse>;
